<h1 mat-dialog-title class="text-align-center text-primary" *ngIf="data.action === 'add'">Add New Tab</h1>
<h1 mat-dialog-title class="text-align-center text-secondary" *ngIf="data.action === 'edit'">Edit Tab Name</h1>
<h1 mat-dialog-title class="text-align-center text-danger" *ngIf="data.action === 'delete'">Are you sure to delete?</h1>

<div mat-dialog-content *ngIf="data.action !== 'delete'" class="row d-flex flex-dir-column justify-content-around vw-30">
  <mat-form-field>
    <mat-label>Tab Name*</mat-label>
    <input matInput placeholder="Enter Name" [(ngModel)]="data.tabObj.name">
  </mat-form-field>
</div>
<div mat-dialog-content *ngIf="data.action === 'delete'" class="row  d-flex flex-dir-column justify-content-center">
  <p class="fs-6">{{data.tabObj.name}}</p>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close (click)="onNoClick()">CANCEL</button>
  <button mat-button cdkFocusInitial class="bg-light-blue text-white" *ngIf="data.action === 'add'" (click)="onAdd()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    CREATE
  </button>
  <button mat-button cdkFocusInitial class="bg-secondary text-white" *ngIf="data.action === 'edit'" (click)="onUpdate()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    UPDATE
  </button>
  <button mat-button cdkFocusInitial class="bg-danger text-white" *ngIf="data.action === 'delete'" (click)="onDelete()">
    <mat-icon *ngIf="loader">
      <mat-spinner [diameter]="20" color="primary"></mat-spinner>
    </mat-icon>
    DELETE
  </button>
</mat-dialog-actions>
